import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import schoolImg from "../img/child.png";
import kidsCta from "../img/both.png";
import Children1Img from "../img/1_children.png";
import AccordionItem from "../components/AccordionItem";
import Protect from "../components/Protect";
import Review from "../components/Review";
import main from "../img/main.png";
import Package from "../components/Package";

const reviews = [
  {
    text: "AngelWatch is the most realistic, engaging, and effective safety training we’ve ever had. Every school should be using this program.",
    name: "James Carter",
    work: "Officer",
  },
  {
    text: "After completing AngelWatch’s training, I finally feel like I know exactly what to do if an emergency happens.",
    name: "Jessica Ramirez",
    work: "Preschool Teacher",
  },
  {
    text: "As a daycare owner, I need to ensure my staff is trained. AngelWatch not only meets state requirements but goes beyond to ensure real-world readiness.",
    name: "Sarah O’Connor",
    work: "Daycare Owner",
  },
];

const faqData = [
  {
    question: "Who needs emergency certification training?",
    answer:
      "All schools, child care centers, and educational institutions need emergency preparedness training. In an emergency, your staff becomes the first responder. AngelWatch ensures your entire team knows exactly what to do — and helps you meet state licensing and audit requirements.",
  },
  {
    question: "What does AngelWatch certification include?",
    answer:
      "AngelWatch Certification includes complete online training for active shooter response, lockdown drills, fire safety, medical emergencies, and natural disasters. Staff receive official certificates upon completion, and administrators gain access to a full compliance dashboard to track training and maintain licensing standards.",
  },
  {
    question: "How long does training take?",
    answer:
      "Most staff members complete their initial training in just a few hours. Courses are designed for maximum flexibility — they can be paused and resumed anytime, ensuring minimal disruption to your school or daycare schedule.",
  },
  {
    question: "Is AngelWatch training state-approved?",
    answer:
      "Yes. AngelWatch meets or exceeds most state licensing requirements for emergency preparedness training. Our system provides the documentation and certificates required for audits, inspections, and legal compliance.",
  },
  {
    question: "What happens if my staff needs retraining?",
    answer:
      "AngelWatch provides automatic annual recertification reminders. Staff can easily retake updated courses as needed to ensure your school or center stays 100% compliant without extra administrative burden.",
  },
  {
    question: "How does AngelWatch help with inspections and audits?",
    answer:
      "Our Emergency Management Dashboard tracks staff certifications and generates reports for licensing inspections. AngelWatch clients report faster, easier inspections — and greater confidence during regulatory reviews.",
  },
  {
    question: "Is this training state approved?",
    answer:
      "Yes. Our Emergency Protocol Handbook and SOPs are written to meet or exceed state Division of Licensing standards nationwide.",
  },
  {
    question: "Do I need to recertify?",
    answer:
      "Staff have unlimited access for 12 months. New hires can be trained anytime, and the system tracks when recertification is due.",
  },
  {
    question: "What if we already have a plan?",
    answer:
      "No problem. Our materials plug right in. If your current plan is incomplete, we’ll rewrite it for free to make it compliant.",
  },
  {
    question: "Do you offer support?",
    answer:
      "Yes. You can email or call us anytime with questions, onboarding help, or integration guidance.",
  },
  {
    question: "Do you offer bulk pricing for districts or franchises?",
    answer: "Yes. Contact us directly for a quote.",
  },
  {
    question: "Is there a maximum number of teachers who can watch it?",
    answer:
      "No. The Center Plan includes unlimited staff access for a full year—train as many staff members as you need.",
  },
  {
    question: "Is there a maximum number of times it can be viewed?",
    answer:
      "No. The course can be watched and reviewed as many times as needed during the 12-month access period.",
  },
  {
    question: "Can the same teacher watch it multiple times?",
    answer:
      "Yes. Staff can log in and review the course at any time throughout the year for refreshers or recertification.",
  },
  {
    question: "Will this make me state compliant?",
    answer:
      "Yes. The training, SOPs, and protocol handbook were designed to align with state mandates and make you inspection-ready.",
  },
  {
    question: "How long until I receive my certificate of completion?",
    answer:
      "Certificates are generated immediately upon successful completion of the interactive course and passing the test.",
  },
  {
    question: "Where can I buy the products used in the videos?",
    answer:
      "Product links and recommendations will be provided after certification or can be accessed via our support team.",
  },
];

const Faq = () => {
  return (
    <div className="bg-white">
      <Header />
      <div className="relative text-white">
        {/* Hero Image */}
        <div className="lg:h-[354px]  h-[150px] w-full overflow-hidden">
          <img
            src={main}
            alt="How it works"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Content Overlay */}

        <div className="absolute inset-0 p-4  flex items-center justify-start">
          <div className="max-w-7xl w-full mx-auto px-4 py-4">
            <div className="flex flex-col">
              <h1
                style={{ fontFamily: "Fredoka" }}
                className="lg:text-[61px] text-[24px] font-bold mb-2 text-white"
              >
                Frequently Asked Questions
              </h1>
              <div
                style={{ fontFamily: "Poppins" }}
                className="lg:text-lg text-sm pb-2 text-white"
              >
                Home &gt;{" "}
                <span className="text-white">Frequently Asked Questions</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto">
        <div>
          <section className="container mx-auto px-4 mt-10 lg:py-12">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h1
                  style={{ fontFamily: "Fredoka" }}
                  className="lg:text-[34px] text-[24px] font-semibold  font-bold text-gray-800 mb-4"
                >
                  Frequently Asked Questions About AngelWatch Certification and
                  School Safety Training
                </h1>
                <p
                  style={{ fontFamily: "poppins" }}
                  className="text-gray-700 mb-4 lg:text-[20px] text-[15px] "
                >
                  We know that choosing the right emergency training program for
                  your school or daycare is an important decision. Below are
                  answers to the most common questions about AngelWatch’s
                  nationally recognized certification, emergency management
                  system, and compliance solutions.
                </p>
              </div>
              <img
                src={schoolImg}
                alt="School kids"
                className="rounded-lg w-full  object-cover"
              />
            </div>

            <div className="mt-12  space-y-4">
              {faqData.map((item, index) => (
                <AccordionItem
                  key={index}
                  question={item.question}
                  answer={item.answer}
                />
              ))}
            </div>
          </section>

          {/* Text + Button */}
          <Protect img={Children1Img} />
        </div>
      </div>
            <div className="pt-14">
      
      <Package/>
            </div>
      <Review reviews={reviews} />
      <Footer />
    </div>
  );
};

export default Faq;
